import {TextField} from "@dvrt/graphql-widgets";
import {KeysMatching} from "@/types";
import {UpdateGatewayData} from "@/api";
import UpdateGatewayForm from "@/components/gateway/update/UpdateGatewayForm";

export type FieldName = keyof UpdateGatewayData;

type TextFieldInputProps<FieldType extends FieldName> = {
    form: UpdateGatewayForm;
    field: FieldType;
    disabled: boolean;
};

export const TextFieldInput = <FieldType extends KeysMatching<UpdateGatewayData, string>>(
    props: TextFieldInputProps<FieldType>,
) => {
    const {form, field, disabled} = props;
    const errors = form.errorHelper.fieldErrors("data." + field);
    return (
        <TextField
            disabled={disabled}
            id={field}
            value={form.values[field]}
            onChange={(value) => form.updateValues({[field]: value})}
            errors={errors}
        />
    );
};
